import React, { useState } from 'react';
import { RocketIcon } from '@radix-ui/react-icons';
import { ElevatedButton } from '@producer/ui-kit';

import { ChangePlanModal } from '../../billing/components/billing-and-plans/change-plan.modal';

import styles from './sso-placeholder.module.scss';
export const SSOPlaceholder = () => {
  const [isSalesModalOpen, setSalesModalOpen] = useState<boolean>();

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <div className={styles['header']}>
          <h2>Secure your data and people with Producer Enterprise</h2>
          <ElevatedButton
            text="Try Producer Enterprise"
            icon={<RocketIcon />}
            onClick={() => setSalesModalOpen(true)}
          />
        </div>

        <div className={styles['grid']}>
          <div className={styles['card']}>
            <h3>SAML single sign-on</h3>
            <p>
              Control and secure access to your resorces within your enterprise's organizations by
              enforcing SAML single sign-on (SSO) through your identity provider (IdP).
            </p>
          </div>

          <div className={styles['card']}>
            <h3>Auto-provisioning with SCIM synchronization</h3>
            <p>
              Manage the lifecycle of your enterprise's user accounts from your identity provider
              (IdP) using System for Cross-domain Identity Management (SCIM).
            </p>
          </div>
        </div>
      </div>

      {isSalesModalOpen && (
        <ChangePlanModal
          title="Contact Sales"
          description='Please contact us at <a href="mailto:sales@the-producer.io">sales@the-producer.io</a> to upgrade your plan.'
          onCancel={() => setSalesModalOpen(false)}
        />
      )}
    </div>
  );
};
